export default "__VITE_ASSET__BQ_JW6iS__"